<template>
    <div class="w-full flex flex-column gap-3 mt-4">
        <div class="w-full flex flex-column gap-2">
            <div class="w-full flex surface-100 h-5rem align-items-center px-3 border-round-xl"
                :class="active === 'get' ? 'border-200 border-2' : ''">
                <div @click="chooseGetCurrency()"
                    class="flex flex-row gap-2 align-items-center surface-100 border-round-lg p-2 cursor-pointer">
                    <Avatar :image="currencyGet?.image" shape="circle" class="flex border-200 border-1" />
                    <span class="flex text-md font-medium text-600 uppercase">
                        {{ currencyGet?.code }}
                    </span>
                </div>
                <div class="flex flex-1 flex-row justify-content-end align-items-center">
                    <span class="flex text-xl font-bold">
                        {{ amountGet }}
                    </span>
                </div>
            </div>
            <div class="w-full flex surface-100 h-5rem justify-content-left align-items-center px-3 border-round-xl"
                :class="active === 'send' ? 'border-200 border-2' : ''">
                <div @click="chooseSendCurrency()"
                    class="flex flex-row gap-2 align-items-center surface-100 border-round-lg p-2 cursor-pointer">
                    <Avatar :image="currencySend?.image" shape="circle" class="flex border-200 border-1" />
                    <span class="flex text-md font-medium text-600 uppercase">
                        {{ currencySend?.code }}
                    </span>
                </div>
                <div class="flex flex-1 flex-row justify-content-end align-items-center">
                    <span class="flex text-xl font-bold">
                        {{ amountSend }}
                    </span>
                </div>
            </div>
        </div>
        <div class="w-full flex flex-column gap-1">
            <div class="grid">
                <div class="col">
                    <div @click="setNum(7)"
                        class="flex justify-content-left align-items-center text-center p-2 border-round-lg surface-100 font-bold h-5rem">
                        <span class="w-full text-2xl">7</span>
                    </div>
                </div>
                <div class="col">
                    <div @click="setNum(8)" 
                        class="flex justify-content-left align-items-center text-center p-2 border-round-lg surface-100 font-bold h-5rem">
                        <span class="w-full text-2xl">8</span>
                    </div>
                </div>
                <div class="col">
                    <div @click="setNum(9)" 
                        class="flex justify-content-left align-items-center text-center p-2 border-round-lg surface-100 font-bold h-5rem">
                        <span class="w-full text-2xl">9</span>
                    </div>
                </div>
                <div class="col">
                    <div @click="rotate()"
                        class="flex justify-content-left align-items-center text-center p-2 border-round-lg surface-600 text-white font-bold h-5rem">
                        <span class="w-full">
                            <Avatar icon="pi pi-sync" shape="circle" class="surface-600 text-white" />
                        </span>
                    </div>
                </div>
            </div>

            <div class="grid">
                <div class="col">
                    <div @click="setNum(4)" 
                        class="flex justify-content-left align-items-center text-center p-2 border-round-lg surface-100 font-bold h-5rem">
                        <span class="w-full text-2xl">4</span>
                    </div>
                </div>
                <div class="col">
                    <div @click="setNum(5)" 
                        class="flex justify-content-left align-items-center text-center p-2 border-round-lg surface-100 font-bold h-5rem">
                        <span class="w-full text-2xl">5</span>
                    </div>
                </div>
                <div class="col">
                    <div @click="setNum(6)" 
                        class="flex justify-content-left align-items-center text-center p-2 border-round-lg surface-100 font-bold h-5rem">
                        <span class="w-full text-2xl">6</span>
                    </div>
                </div>
                <div class="col">
                    <div @click="delNum()" 
                        class="flex justify-content-left align-items-center text-center p-2 border-round-lg surface-600 text-white font-bold h-5rem">
                        <span class="w-full">
                            <Avatar icon="pi pi-arrow-left" shape="circle" class="surface-600 text-white" />
                        </span>
                    </div>
                </div>
            </div>
            
            <div class="grid">
                <div class="col">
                    <div @click="setNum(1)" 
                        class="flex justify-content-left align-items-center text-center p-2 border-round-lg surface-100 font-bold h-5rem">
                        <span class="w-full text-2xl">1</span>
                    </div>
                </div>
                <div class="col">
                    <div @click="setNum(2)" 
                        class="flex justify-content-left align-items-center text-center p-2 border-round-lg surface-100 font-bold h-5rem">
                        <span class="w-full text-2xl">2</span>
                    </div>
                </div>
                <div class="col">
                    <div @click="setNum(3)" 
                        class="flex justify-content-left align-items-center text-center p-2 border-round-lg surface-100 font-bold h-5rem">
                        <span class="w-full text-2xl">3</span>
                    </div>
                </div>
                <div class="col">
                    <div @click="clean()" 
                        class="flex justify-content-left align-items-center text-center p-2 border-round-lg surface-600 text-white font-bold h-5rem">
                        <span class="w-full text-2xl">C</span>
                    </div>
                </div>
            </div>

            <div class="grid">
                <div class="col">
                    <div @click="setNum(0)" 
                        class="flex justify-content-left align-items-center text-center p-2 border-round-lg surface-100 font-bold h-5rem">
                        <span class="w-full text-2xl">0</span>
                    </div>
                </div>
                <div class="col">
                    <div @click="dot()" 
                        class="flex justify-content-left align-items-center text-center p-2 border-round-lg surface-100 font-bold h-5rem">
                        <span class="w-full text-2xl">.</span>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <Dialog v-model:visible="popupGet" modal @hide="closePopups"
        class="w-full border-round-xl overflow-hidden border-none surface-100"
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : 'max-w-30rem'">

        <template #header>
            <span class="text-lg font-medium">{{ content[lang].getCurrency }}</span>
        </template>

        <div class="flex w-full mb-3">
            <IconField class="w-full">
                <InputIcon>
                    <i class="pi pi-search" />
                </InputIcon>
                <InputText v-model="searchCurrency" :placeholder="content[lang].search" class="w-full border-2 border-round-lg"/>
                <InputIcon v-if="searchCurrency">
                    <i class="pi pi-times cursor-pointer" @click="searchCurrency=''"/>
                </InputIcon>
            </IconField>
        </div>

        <div v-if="currencies && filteredCurrencies"
            class="flex flex-column gap-3 xl:py-4 xl:px-1 lg:py-3 md:py-2">
            <MobMenu>
                <template v-slot:body>
                    <div v-for="currency of filteredCurrencies" @click="setGetCurrency(currency)"
                        class="w-full flex flex-row gap-2 px-3 py-2 border-100 cursor-pointer border-bottom-1" style="min-height:65px">
                        <div class="flex flex-row flex-1 gap-2">
                            <div class="flex">
                                <AvatarGroup>
                                    <Avatar :image="getCurImage(currency)" class="w-full surface-0" shape="circle"/>
                                </AvatarGroup>
                            </div>
                            <div class="flex-1 flex flex-column gap-1 justify-content-center">
                                <div class="w-full relative flex overflow-hidden h-1rem" >
                                    <div class="absolute left-0 top-0 font-medium text-sm xl:text-md white-space-nowrap">
                                        <span class="mr-1 uppercase">
                                            {{ currency.code }}
                                        </span>
                                    </div>
                                </div>
                                <div class="flex font-medium text-500 text-xs xl:text-md white-space-nowrap">
                                    <span>
                                        {{ currency.name }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </MobMenu>
        </div>
    </Dialog>

    <Dialog v-model:visible="popupSend" modal @hide="closePopups"
        class="w-full border-round-xl overflow-hidden border-none surface-100"
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : 'max-w-30rem'">

        <div class="flex w-full mb-3">
            <IconField class="w-full">
                <InputIcon>
                    <i class="pi pi-search" />
                </InputIcon>
                <InputText v-model="searchCurrency" :placeholder="content[lang].search" class="w-full border-2 border-round-lg"/>
                <InputIcon v-if="searchCurrency">
                    <i class="pi pi-times cursor-pointer" @click="searchCurrency=''"/>
                </InputIcon>
            </IconField>
        </div>

        <template #header>
            <span class="text-lg font-medium">{{ content[lang].sendCurrency }}</span>
        </template>
        <div v-if="currencies && filteredCurrencies"
            class="flex flex-column gap-3 xl:py-4 xl:px-1 lg:py-3 md:py-2">
            <MobMenu>
                <template v-slot:body>
                    <div v-for="currency of filteredCurrencies" @click="setSendCurrency(currency)"
                        class="w-full flex flex-row gap-2 px-3 py-2 border-100 cursor-pointer border-bottom-1" style="min-height:65px">
                        <div class="flex flex-row flex-1 gap-2">
                            <div class="flex">
                                <AvatarGroup>
                                    <Avatar :image="getCurImage(currency)" class="w-full surface-0" shape="circle"/>
                                </AvatarGroup>
                            </div>
                            <div class="flex-1 flex flex-column gap-1 justify-content-center">
                                <div class="w-full relative flex overflow-hidden h-1rem" >
                                    <div class="absolute left-0 top-0 font-medium text-sm xl:text-md white-space-nowrap">
                                        <span class="mr-1 uppercase">
                                            {{ currency.code }}
                                        </span>
                                    </div>
                                </div>
                                <div class="flex font-medium text-500 text-xs xl:text-md white-space-nowrap">
                                    <span>
                                        {{ currency.name }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </MobMenu>
        </div>
    </Dialog>
</template>

<script>
import Connect from '@/assets/js/Connect.js'
import Helper from '@/assets/js/Helper.js'
import MobMenu from '@/components/sides/menu/MobMenu.vue'
import { mapActions } from "vuex"
import BigNumber from 'bignumber.js'

export default {
    data() {
        return {
            content: {
                ru:{
                    getCurrency: "Валюта приема",
                    sendCurrency: "Валюта получения",
                    search: "Поиск",
                },
                en:{
                    getCurrency: "Get Currency",
                    sendCurrency: "Send Currency",
                    search: "Search",
                },
            },
            popupGet: false,
            popupSend: false,
            active: 'get',
            amountGet: 1,
            amountSend: 0,
            currencies: [],
            filteredCurrencies: [],
            currencyGet: null,
            currencySend: null,
            rates: [],
            rate: null,
            searchCurrency: null
        }
    },
    methods:{
        ...mapActions(["GetCurrencies"]),
        setNum(num) {
            // console.log('setNum', num, this.rate);
            if (this.active === 'get') {
                this.amountGet = (this.amountGet === 0) ? num : this.amountGet.toString() + num.toString();
                // this.amountSend = (this.amountGet * this.rate).toFixed(2);
                this.amountSend = BigNumber(this.amountGet).multipliedBy(this.rate).toFixed(2);
            } else {
                this.amountSend = (this.amountSend === 0) ? num : this.amountSend.toString() + num.toString();
                this.amountGet = BigNumber(this.amountSend).dividedBy(this.rate).toFixed(2);
            }
            // console.log('setNum', this.amountGet, this.amountSend, this.rate);
        },
        delNum() {
            if (this.amountGet.toString().length > 1) {
                this.amountGet = this.amountGet.toString().slice(0, -1);
            } else {
                this.amountGet = 0;
            }
            this.amountSend = BigNumber(this.amountGet).multipliedBy(this.rate).toFixed(2);
        },
        dot() {
            if (this.active === 'get') {
                if (!this.amountGet.toString().includes('.')) {
                    this.amountGet = this.amountGet.toString() + '.';
                }
            } else {
                if (!this.amountSend.toString().includes('.')) {
                    this.amountSend = this.amountSend.toString() + '.';
                }
            }
            // console.log('dot', this.amountGet, this.amountSend, this.rate);
        },
        rotate(){
            if(this.active === 'get') {
                this.active = 'send';
                this.amountSend = '1'
                this.amountGet = BigNumber(this.amountSend).dividedBy(this.rate).toFixed(2);
            } else {
                this.active = 'get';
                this.amountGet = '1'
                this.amountSend = BigNumber(this.amountGet).multipliedBy(this.rate).toFixed(2);
            }
            // console.log('rotate', this.active, this.amountGet, this.amountSend, this.rate);
        },  
        clean() {
            this.amountSend = 0;
            this.amountGet = 0;
        },
        chooseGetCurrency() {
            this.popupGet = true
        },
        chooseSendCurrency() {
            this.popupSend = true
        },
        setGetCurrency(currency) {
            this.currencyGet = currency
            this.popupGet = false
            this.rate = this.getRate(this.currencyGet.code, this.currencySend.code)
            // console.log('setGetCurrency', this.currencyGet, this.currencySend, this.rate)
            this.amountGet = 1
            // this.amountSend = (this.amountGet * this.rate).toFixed(2)
            this.amountSend = BigNumber(this.amountGet).multipliedBy(this.rate).toFixed(2);
        },
        setSendCurrency(currency) {
            this.currencySend = currency
            this.popupSend = false
            this.rate = this.getRate(this.currencyGet.code, this.currencySend.code)
            // console.log('setSendCurrency', this.currencyGet, this.currencySend, this.rate)
            this.amountSend = 1
            // this.amountGet = (this.amountSend / this.rate).toFixed(2)
            this.amountGet = BigNumber(this.amountSend).dividedBy(this.rate).toFixed(2);
        },
        getCurImage(currency) {
            if (currency && currency.image) return currency.image;
            else return '/images/svg/other.svg'
        },
        getRate(from, to) {
            if(!from || !to) return 0;
            if(!this.rates) return 0;
            const getRate = (this.rates[from.toUpperCase()]) ? this.rates[from.toUpperCase()] : null;
            const sendRate = (this.rates[to.toUpperCase()]) ? this.rates[to.toUpperCase()] : null;
            // console.log('<>', getRate, sendRate);

            if (getRate && sendRate) {
                return BigNumber(getRate).multipliedBy(sendRate).toNumber();
            } else {
                console.error('Error: Rates not found for currencies', from, to);
                return 0;
            }
        },
        closePopups() {
            this.popupGet = false;
            this.popupSend = false;
            this.searchCurrency = '';
            this.filteredCurrencies = this.currencies;
        }
    },
    watch: {
        searchCurrency(val) {
            if(!val || val.length == 0){
                this.filteredCurrencies = this.currencies
                return false
            }
            const lowVal = val.toLowerCase()
            if(!this.currencies) return false
            if(!this.currencies || Object.keys(this.currencies).length == 0) return false
            this.filteredCurrencies = []
            for(const [k, v] of Object.entries(this.currencies)){
                const code = v.code.toLowerCase()
                const name = v.name.toLowerCase()
                if(code.includes(lowVal) || name.includes(lowVal)){
                    this.filteredCurrencies.push(v)
                }
            }
        }
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'en' },
        screenSize() { return this.$store.getters.StateScreenSize },
    },
    components: {
        MobMenu
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        // this.rate = this.rates.find(rate => rate.id === 'idr').rate;
        // this.amountGet = (this.amountSend * this.rate).toFixed(2);

        const storeCurrencies = this.$store.getters.GetCurrencies
        if(storeCurrencies && Object.keys(storeCurrencies).length) this.currencies = Object.values(storeCurrencies).map(currency => ({
            code: currency.code,
            name: currency.name,
            image: currency.image
        }))
        else {
            const resCurrencies = await this.$store.dispatch('GetCurrencies').then(res => res)
            if (!resCurrencies.result || !resCurrencies.data || resCurrencies.data.length <= 0){
                // this.totalError = true
                // this.totalErrorMessage = 'No currencies loaded' // TODO: вывести ошибку на разных языках
                return
            }
            // Преобразуем объект currencies в массив
            this.currencies = Object.values(resCurrencies.data).map(currency => ({
                code: currency.code,
                name: currency.name,
                image: currency.image
            }));
        }
        this.filteredCurrencies = this.currencies
        this.currencyGet = this.currencies[0]
        this.currencySend = this.currencies[1]
        // console.log('currencyGet', this.currencyGet)
        // console.log('currencies', this.currencies)

        const resRates = await this.connect.GetRatesForConverter().then(res => res)
        if (resRates && resRates.result) this.rates = resRates.data;

        this.rate = this.getRate(this.currencyGet.code, this.currencySend.code)
        // console.log('rate', this.rate)
    }
}
</script>